import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./style/reset.less";

const app = createApp(App);

const pinia = createPinia();

app.use(pinia).use(router).mount("#app");
